// @flow
import ApiClient from 'utils/ApiClient';
import Dispatcher from 'dispatcher';
import {
  SET_HOME,
  COMMENTS_HOME,
  COMMENT_CREATED,
  HOME_UPDATED,
  HOME_REJECTED
} from 'modules/external_tenant/api/action_types/HomeActionTypes';

class HomeActions {
  createHome = (applicationId: string) => {
    return ApiClient.post({
      path: `/homes`,
      jsonData: {
        home_application_id: applicationId,
        role: 'owner'
      }
    }).then(response => {
      Dispatcher.dispatch({ type: SET_HOME, payload: response.home });
      return response.home.id;
    });
  };

  getInfoHome(home_id: string): Promise<any> {
    return ApiClient.get({
      path: `/homes/${home_id}/info.json`
    }).then(response => {
      Dispatcher.dispatch({ type: SET_HOME, payload: response.home });
    });
  }

  updInfoHome(home_id: string, data: any): Promise<any> {
    return ApiClient.post({
      path: `/homes/${home_id}/external_rents.json`,
      jsonData: data
    }).then(response => {
      Dispatcher.dispatch({ type: HOME_UPDATED, payload: response.home });
    });
  }

  rejectHome(homeId: string) {
    return ApiClient.post({
      path: `/homes/${homeId}/external_rents/reject`
    }).then(() => {
      Dispatcher.dispatch({ type: HOME_REJECTED });
    });
  }

  createComment = (contentData: string, home_id: string) => {
    return ApiClient.post({
      path: `/homes/${home_id}/comments.json`,
      jsonData: {
        content: contentData
      }
    }).then(response => {
      Dispatcher.dispatch({ type: COMMENT_CREATED, payload: response.comment });
    });
  };

  getComments = (home_id: string) => {
    return ApiClient.get({
      path: `/homes/${home_id}/comments.json`
    }).then(response => {
      Dispatcher.dispatch({ type: COMMENTS_HOME, payload: response.comments });
    });
  };
}

export default new HomeActions();
